import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/contexts/AuthContext";
import { PageSpinner } from "@/components/PageSpinner";
import type { LoginRedirectState } from "@/lib/login-redirect";

/**
 * Gates account pages behind a live session; sends anonymous visitors to /login, remembering
 * the requested page so a shared product link survives the login.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <PageSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location } satisfies LoginRedirectState} />;
  }

  return <Outlet />;
}
